// Regla de cobro de parqueadero de visitantes. La app móvil replica esta misma
// lógica en coordiph/lib/function/cobro_parqueadero.dart; si se cambia aquí,
// debe cambiarse allá para que ambas cobren igual.

export const MINUTOS_GRATIS_DEFECTO = 60;
export const MINUTOS_FRANJA_DEFECTO = 12 * 60;

const esNumero = (n) => typeof n === "number" && !isNaN(n);

export const minutosGratisDe = (conjunto) => {
  const minutos = parseInt(conjunto?.minutosGratisParqueadero, 10);
  if (esNumero(minutos) && minutos >= 0) return minutos;
  const horas = parseFloat(conjunto?.horasGratisParqueadero);
  if (esNumero(horas) && horas >= 0) return Math.round(horas * 60);
  return MINUTOS_GRATIS_DEFECTO;
};

export const minutosFranjaDe = (conjunto) => {
  const minutos = parseInt(conjunto?.minutosFranjaParqueadero, 10);
  return esNumero(minutos) && minutos > 0 ? minutos : MINUTOS_FRANJA_DEFECTO;
};

export const tarifaDesdeConjunto = (conjunto, esMoto) => {
  const franjaGuardada = esMoto ? conjunto?.valorFranjaMoto : conjunto?.valorFranjaCarro;
  const horaGuardada = esMoto ? conjunto?.valorHoraMoto : conjunto?.valorHoraCarro;
  const franjaConfigurada = franjaGuardada !== null && franjaGuardada !== undefined;

  // Sin franja configurada, valorHora* guarda la tarifa antigua de franja.
  return {
    minutosGratis: minutosGratisDe(conjunto),
    minutosFranja: minutosFranjaDe(conjunto),
    valorFranja: parseFloat(franjaGuardada ?? horaGuardada) || 0,
    // null = sin valor por hora (el sobrante se cobra como franja); 0 = gratis.
    valorHora: franjaConfigurada && esNumero(parseFloat(horaGuardada)) ? parseFloat(horaGuardada) : null,
  };
};

// El cobro empieza al terminar el tiempo gratuito. Cada franja completa se
// cobra a valor de franja; el tiempo restante se cobra por hora (fracción =
// hora completa) sin superar el valor de una franja. Si no hay valor por hora,
// el tiempo restante se cobra como una franja. Un valor 0 no se cobra.
export const calcularCobro = (tarifa, minutos) => {
  const minutosCobrables = Math.max(minutos - tarifa.minutosGratis, 0);
  const franjasCompletas = Math.floor(minutosCobrables / tarifa.minutosFranja);
  const horasSobrantes = Math.ceil((minutosCobrables % tarifa.minutosFranja) / 60);

  let valorHorasSobrantes = 0;
  if (horasSobrantes > 0) {
    const porHora = horasSobrantes * tarifa.valorHora;
    valorHorasSobrantes =
      tarifa.valorHora === null || porHora > tarifa.valorFranja ? tarifa.valorFranja : porHora;
  }

  return {
    minutosCobrables,
    franjasCompletas,
    horasSobrantes,
    valorHorasSobrantes,
    total: franjasCompletas * tarifa.valorFranja + valorHorasSobrantes,
  };
};

// Casos de ejemplo para mostrar al configurar las tarifas.
export const ejemplosCobro = (minutosGratis, minutosFranja) => {
  const gratis = formatearDuracion(minutosGratis);
  const prefijo = minutosGratis > 0 ? `${gratis} gratis + ` : "";
  const franja = formatearDuracion(minutosFranja);

  const caso = (descripcion, extra) => {
    const total = minutosGratis + extra;
    return {
      descripcion:
        minutosGratis > 0 && extra > 0
          ? `${prefijo}${descripcion} = ${formatearDuracion(total)}`
          : descripcion,
      minutos: total,
    };
  };

  return [
    minutosGratis > 0
      ? { descripcion: `Tiempo gratuito: ${gratis}`, minutos: minutosGratis }
      : { descripcion: "Sin tiempo gratuito", minutos: 0 },
    caso("1 h", 60),
    caso("2 h", 120),
    caso(`1 franja (${franja})`, minutosFranja),
    caso("1 franja + 2 h", minutosFranja + 120),
  ];
};

// 90 -> "1 h 30 min", 720 -> "12 h", 45 -> "45 min", 0 -> "0 min".
export const formatearDuracion = (minutos) => {
  const h = Math.floor(minutos / 60);
  const m = minutos % 60;
  if (h === 0) return `${m} min`;
  return m === 0 ? `${h} h` : `${h} h ${m} min`;
};
